import { render, staticRenderFns } from "./need-modify-pwd.vue?vue&type=template&id=1237be9f&scoped=true&"
import script from "./need-modify-pwd.vue?vue&type=script&lang=js&"
export * from "./need-modify-pwd.vue?vue&type=script&lang=js&"
import style0 from "./need-modify-pwd.vue?vue&type=style&index=0&id=1237be9f&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1237be9f",
  null
  
)

export default component.exports